import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="text-center">
        <p className="text-green-500 font-black text-8xl mb-4">404</p>
        <h1 className="text-2xl font-black text-white mb-2">PAGE NOT FOUND</h1>
        <p className="text-white/40 mb-8 text-sm">
          This page doesn't exist or has been moved.
        </p>
        <Link
          to="/"
          className="inline-block px-8 py-4 bg-green-500 text-black font-bold uppercase tracking-wider text-sm hover:bg-green-400 transition-colors duration-300"
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
}
